// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_59-0";
export var eligibilityCardNotEligible = "_59-1";